<template>
  <div class="dashboard">
    <div class="dashboard__container">
      <div class="dashboard__container--header">
        <h1>Settings</h1>
        <span class="flex align-center flex-wrap">
          <router-link :to="{name: 'manageSkills'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isManageSkills, 'btn__outlined': !isManageSkills }">Manage Skills</button>
          </router-link>
          <router-link :to="{name: 'manageCategories'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isManageCategories, 'btn__outlined': !isManageCategories }">Manage Categories</button>
          </router-link>
          <router-link :to="{name: 'manageCerts'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isManageCerts, 'btn__outlined': !isManageCerts }">Manage Certs</button>
          </router-link>
          <!-- <router-link :to="{name: 'paidAssignments'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaidAssignments, 'btn__outlined': !isPaidAssignments }">Paid Assignments</button>
          </router-link>
          <router-link :to="{name: 'backgroundChecks'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isBackgroundChecks, 'btn__outlined': !isBackgroundChecks }">Background Checks</button>
          </router-link>
          <router-link :to="{name: 'onboardingEmployees'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isOnboardingEmployees, 'btn__outlined': !isOnboardingEmployees }">Onboarding Employees</button>
          </router-link> -->

          <button class="btn btn__outlined btn__small" @click="goBack()"><i class="fas fa-arrow-left"></i></button>
        </span>
        
      </div>
      <router-view :key="$route.params.id" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router'

export default {
  name: 'settingsHome',
  computed: {
    ...mapState(['currentUser', 'userProfile']),
    isManageSkills() {
      return this.$route.name == 'manageSkills';
    },
    isManageCategories() {
      return this.$route.name == 'manageCategories';
    },
    isManageCerts() {
      return this.$route.name == 'manageCerts';
    },
    // isBackgroundChecks() {
    //   return this.$route.name == 'backgroundChecks';
    // },
    // isEvereeUsersWithoutExternalId() {
    //   return this.$route.name == 'evereeUsersWithoutExternalId';
    // },
    // isNonContractors() {
    //   return this.$route.name == 'nonContractors';
    // },
    // isOnboardingEmployees() {
    //   return this.$route.name == 'onboardingEmployees';
    // },
    // isPaidAssignments() {
    //   return this.$route.name == 'paidAssignments';
    // },
  },
  methods: {
    goBack() {
      router.go(-1)
    },
  },
}
</script>